import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { apiURL_BACKEND, UserDataInterface, ProductDataInterface, PaymentCartInterface, apiMediaURL_BACKEND, useJustifyUserType } from './Vars';
import style from './css/CheckOutPage.module.css';
import { useNavigate } from 'react-router-dom';
interface CheckOutProps {

}



const CheckOut: React.FC<CheckOutProps> = () => {
    const navigate = useNavigate();
    const userType = useJustifyUserType();
    const [userData, setUserData] = useState<UserDataInterface>();
    const [currentPayCurrency, setCurrentCurrency] = useState<string | any>("BTC");

    const [productType, setProductType] = useState<string | any | null>(null);
    const [productID, setProductID] = useState<any | null | number>(null);


    const [form1Visibility, setform1Visibility] = useState<boolean>(true);
    const [form2Visibility, setform2Visibility] = useState<boolean>(false);
    const [form3Visibility, setform3Visibility] = useState<boolean>(false);
    const [form4Visibility, setform4Visibility] = useState<boolean>(false);

    const [payAmount, setPayAmount] = useState<number>(0);
    const [paymentCart, setPaymentCart] = useState<PaymentCartInterface | null>(null);

    const [initiatePurchase__, setInitatePurchase__] = useState<boolean>(false);

    const [product, setProduct] = useState<ProductDataInterface | null>(null);

    const [statusOk, setStatusOk] = useState<boolean>(false);
    const [statusError_, setStatusError] = useState<boolean>(false);
    const [statusMessage, setStatusMessage] = useState<string>("")
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const productType = params.get("type"); // Get the value of the 'ref' query parameter
        const pID = params.get("productID"); // Get the value of the 'ref' query parameter
        setProductID(pID);
        setProductType(productType);
    }, []);


    useEffect(() => {

        if (productID && productType && userData) {

            if (productType.toLowerCase() == "PackagePass".toLowerCase()) {
                if (!userData.package && userData.user_type == "Agent") {
                    return;
                }
            }
            const res = axios.get(`${apiURL_BACKEND}/getProductInfo/?type=${productType}&productID=${productID}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                },
            }).then((res) => {

                console.log(res)
                setProduct({
                    name: res.data.name,
                    price: res.data.price,
                    type: res.data.type
                })

            }).catch((err) => (console.log(err)));
        }
    }, [productID, productType, userData])



    const payCurrencies: { [key: string]: string } = {
        "BTC": "Bitcoin",
        "USDC": "USDC ERC-20",
        "USDCSOL": "USDC SOLANA",
        "USDTBSC": "USDT BEP-20",
        "USDTERC20": "USDT ERC-20",
        "USDTTRC20": "USDT TRC20"
    }

    useEffect(() => {
        const res = axios.get(`${apiURL_BACKEND}/getUser/`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
            },
        }).then((res) => {
            var data = res.data;
            console.log("uerdata - > ", data);

            setUserData({
                username: data.username,
                email: data.email,
                referrer: data.referrer,
                refer_code: data.refer_code,
                date_joined: data.date_joined,
                package: data.package,
                balance: data.balance,
                user_type: data.user_type,
                tme_username:data.tme_username
            })
        });
    }, [])

    // COPY WALLET

    const [copied, setCopied] = useState(false);
    useEffect(() => {
        if (copied) {
            alert("Copied !");
        }
    }, [copied]);
    const handleCopy = async (element_id: string) => {
        try {

            var el = document.getElementById(element_id);
            if (el) {
                var textToCopy = el.innerText;
                navigator.clipboard.writeText(textToCopy);
                setCopied(true);
                setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
            }


        } catch (err) {
            console.error("Failed to copy text:", err);
        }
    };


    const [currencyVisibility, setCurrencyVisibility] = useState<boolean>(false);
    const changeCurrencyVisibility = () => {
        setCurrencyVisibility(!currencyVisibility);
    }
    const changeCurrency = (key: string) => {
        setCurrentCurrency(key);
        changeCurrencyVisibility();
    }




    const Form_submit = (eventType: string) => {


        if (eventType == "recharge") {
            setform1Visibility(false);
            setform2Visibility(true);

        }
        else if (eventType == "CanclePayment") {
            setform1Visibility(true);
            setform2Visibility(false);
        }
        else if (eventType == "ProceedToPayment") {

            if (payAmount <= 0) {
                alert("Pay amount is 0");
                return 0;
            }
            setform3Visibility(true);
            setform2Visibility(false);
            axios.post(`${apiURL_BACKEND}/createPaymentRequest/`, {
                "amount": payAmount,
                "currency": currentPayCurrency
            },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                    },
                }).then((res) => {
                    console.log(res);
                    setPaymentCart({
                        payID: res.data.paymentID,
                        qrImageURL: res.data.payQR,
                        payCurrency: res.data.currency,
                        payAddress: res.data.pay_address,
                        payAmount: res.data.amount,
                        expireAt: res.data.expireAt,
                        fiatAmount: res.data.fiatAmount
                    })




                }
                ).catch((err) => {
                    setform3Visibility(false);
                    setform2Visibility(true);
                    alert("Failed to generate Payment Request");
                })
        }

        else if (eventType == "PaymentConfirmed") {
            if (paymentCart) {
                axios.post(`${apiURL_BACKEND}/paymentConfirmation/`, {
                    "status": eventType,
                    "paymentID": paymentCart.payID
                },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                        },
                    }).then((res) => {
                        console.log(res);
                        alert(res.data.message + "\n\nIt usually takes one hour to process payments");

                        setTimeout(() => {
                            navigate("/dashboard/")
                        }, 1500)
                    }
                    ).catch((err) => {
                        alert("Payment Failed");
                        setTimeout(() => {
                            navigate("/dashboard/")
                        }, 1500)
                    })
            }
        }

        else if (eventType == "BuyWithBalance") {
            setform1Visibility(false);
            setform2Visibility(false);
            setform3Visibility(false);
            setform4Visibility(true);
            setInitatePurchase__(true)
        }
    }

    const initiatePurchase = () => {
        if (initiatePurchase__) {
            setInitatePurchase__(false);
            axios.post(`${apiURL_BACKEND}/makePurchase/`, {
                "type": productType,
                "productID": productID
            }
                , {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                        "Content-Type": "application/json"
                    },
                }
            ).then(
                (res) => {
                    var data = res.data;
                    console.log(data)
                    setStatusOk(true);
                    setStatusError(false);
                    setStatusMessage(data.message);


                    setTimeout(() => {
                        navigate("/dashboard/");
                    }, 2500)

                }
            ).catch((err) => {
                console.log(err.response.data.err)
                setStatusOk(false);
                setStatusError(true);
                setStatusMessage(err.response.data.err);
                setTimeout(() => {
                    navigate("/dashboard/");
                }, 2500)
            })
        }

    }

    return (
        <>

            {/* show payment detail form  */}
            <div className={style.checkClass}>
                {
                    form3Visibility ? (
                        <>
                            <form method="get" action="" className={style.addCage} id="add-cage" style={{ zIndex: 100000000000000 }}>
                                <p className={style.cageTitle}>MAKE PAYMENTS</p>

                                <div className={style.addCageSec}>
                                    <p className={style.addCageSec_t1}>Your wallet address </p>
                                    <div className={style.addCageSecAddress}>
                                        <p id='payAddress'>{paymentCart?.payAddress}</p>
                                        <div className="copy">
                                            <span className={`material-symbols-outlined ${style.copyButton}`} onClick={(e) => { e.preventDefault(); handleCopy("payAddress") }}>
                                                content_copy
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div className={style.addCageSec}>
                                    <p className={style.addCageSec_t1}>Amount To Pay </p>
                                    <div className={style.addCageSecAddress}>
                                        <p id='amountMoney'>{paymentCart?.payAmount}</p>
                                        <div className="copy">
                                            <span className={`material-symbols-outlined ${style.copyButton}`} onClick={(e) => { e.preventDefault(); handleCopy("amountMoney") }}>
                                                content_copy
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className={style.addCageSec}>
                                    <p className={style.addCageSec_t1}>Fiat Amount </p>
                                    <div className={style.addCageSecAddress}>
                                        <p id='amountMoney'>{paymentCart?.fiatAmount} $</p>
                                    </div>
                                </div>
                                <div className={style.addCageSec1}>
                                    <img src={`${apiMediaURL_BACKEND}/qr/${paymentCart?.qrImageURL}`} alt="" />
                                </div>

                                <div className={style.addCage1Sec2}>
                                    <p className={style.addCageSec2_t1}>Usually takes 1 hour to confirm the payments</p>
                                    <p className={style.addCageSec2_t2}>Please press the confirm button after making the payment</p>
                                    <p className={style.addCageSec2_t2} style={{ whiteSpace: "pre" }}><br></br>
                                        Due amount :  <code>{paymentCart?.payAmount}</code> $ <br></br>

                                        Fait amount in USD : {paymentCart?.fiatAmount}$ <br></br>

                                        Valid until : {paymentCart?.expireAt}
                                    </p>
                                </div>

                                <div className={style.addCage1Sec3}>
                                    <button className={style.addCage1Sec3ConfirmButton} name="confirm" value="" onClick={(e) => { e.preventDefault(); Form_submit("PaymentConfirmed") }}>Confirm</button>
                                    <div className={style.addCage1Sec3CancleButton} onClick={(e)=>{e.preventDefault();navigate("/dashboard/")}}>Cancel</div>
                                </div>
                            </form>
                        </>
                    ) :
                        (<></>)
                }


                {
                    product && form1Visibility ? (
                        <>
                            <form method="post" className={style.buyPackage} id="add-cage">

                                <p className={style.buyPackageTitle}>Buy Package</p>
                                <input type="hidden" name="currency" id="currency-input" value="USDCSOL" />
                                <div className={style.buyPackageSec}>
                                    <p className={style.buyPackageSec_p}>Your Balance</p>
                                    <input type="text" className={style.buyPackageSec_input} readOnly value={`${userData?.balance ?? 0} $`} />
                                    {userData?.balance !== undefined && product?.price !== undefined ? (
                                        userData.balance < product.price ? (
                                            <p className={style.buyPackageSecLowBalance}>Not enough balance</p>
                                        ) : (
                                            <></>
                                        )
                                    ) : (
                                        <></>
                                    )}
                                </div>
                                <div className={style.buyPackageSection_1}>
                                    <div className={style.buyPackageSection_1_Data}>
                                        <div>Package Type &nbsp; &nbsp; : </div>
                                        <div>{product?.name} {product?.type}</div>
                                    </div>
                                    <div className={style.buyPackageSection_1_Data}>
                                        <div>Price &nbsp; &nbsp; : </div>
                                        <div>{product?.price}$</div>
                                    </div>
                                </div>
                                <div className={style.buyPackageSection_2}>
                                    <button type="submit" className={style.confirmButton} onClick={(e) => { e.preventDefault(); Form_submit("recharge") }}>Recharge & Buy</button>

                                    <div>
                                        <div className={product?.price > (userData?.balance ? userData.balance : 0) ? style.addCage1Sec3CancleButton : style.confirmButton} style={{whiteSpace:"pre"}} onClick={(e) => { e.preventDefault(); Form_submit("BuyWithBalance") }}>Buy With Main Balance</div>
                                        {
                                            product?.price > (userData?.balance ? userData.balance : 0) ? (
                                                <p className={style.buyPackageSecLowBalance}>Not enough balance</p>

                                            ) : (
                                                <></>
                                            )
                                        }

                                    </div>
                                </div>
                            </form>
                        </>
                    ) :
                        (<></>)
                }


                {
                    form2Visibility ? (
                        <>
                            <form method="post" className={style.buyPackage} id="add-cage">

                                <p className={style.buyPackageTitle}>Add to Balance</p>
                                <input type="hidden" name="currency" id="currency-input" value="BTC" />
                                <div className={style.buyPackageSec}>
                                    <p className={style.buyPackageSec_p}>Enter amount</p>
                                    <input type='number' className={style.buyPackageSec_input} placeholder='Enter an amount in USD $' required onChange={(e) => { setPayAmount(Number(e.target.value)) }} />
                                </div>


                                <div className={style.selectCurrency}>

                                    <div className="t1">Choose Currency</div>
                                    <div className="dropdown">
                                        <div className="dropdown-field" id="dropdownField" onClick={(e) => { e.preventDefault(); changeCurrencyVisibility(); }}>
                                            <div className="drop-down-text" id="drop-down-text">
                                                <div className="currency-name">{payCurrencies[currentPayCurrency]}</div>
                                                <img src={`/media/${currentPayCurrency}.png`} alt="" />
                                            </div>
                                            <div className="drop-down-icon" id="drop-down-icon">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M12 15L7 10H17L12 15Z" fill="#5F6368" />
                                                </svg>
                                            </div>
                                        </div>

                                        {
                                            currencyVisibility ? (
                                                <div className="dropdown-list" id="dropdownList">
                                                    {
                                                        Object.entries(payCurrencies).map(([key, value]) => (

                                                            <>
                                                                <div className="dropdown-item" id="currency-{{coin.symbol}}">
                                                                    <div className="drop-down-text" id="drop-down-text" onClick={(e) => { e.preventDefault(); changeCurrency(key) }}>
                                                                        <div className="currency-name">{value}</div>
                                                                        <img src={`/media/${key}.png`} alt="" />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        ))
                                                    }


                                                </div>
                                            ) :
                                                (<></>)
                                        }

                                    </div>
                                </div>


                                <div className={style.buyPackageSection_2}>
                                    <button type="submit" className={style.confirmButton} onClick={(e) => { e.preventDefault(); Form_submit("ProceedToPayment") }} >PROCCEED</button>

                                    <div>
                                        <div className={style.addCage1Sec3CancleButton} onClick={(e) => { e.preventDefault(); Form_submit("CanclePayment") }} >CANCLE</div>

                                    </div>
                                </div>



                            </form>
                        </>
                    ) :
                        (
                            <>

                            </>
                        )
                }

                {
                    form4Visibility ? (
                        (!statusOk && statusError_ == false) ? (
                            <form action="" className={style.buyConfirmForm} onSubmit={(e) => { e.preventDefault(); initiatePurchase() }}>
                                <p>Please Click on Confirm to Proceed !</p>
                                <img src="/media/safe.png" alt="" />
                                <button type="submit">CONFIRM</button>
                            </form>
                        ) : (
                            <>
                                <form action="" className={style.buyConfirmForm}>
                                    {
                                        statusOk ? (<>
                                            <p>{statusMessage}</p>
                                            <img src="/media/cong.png" alt="" />
                                        </>) : (<></>)
                                    }

                                    {
                                        statusError_ ? (<>
                                            <p>{statusMessage}</p>
                                            <img src="/media/warning.png" alt="" />
                                        </>) : (<></>)
                                    }
                                    <button type="button" style={{ backgroundColor: "red" }}>OK</button>
                                </form>

                            </>
                        )

                    ) :
                        (
                            <></>
                        )
                }

            </div>








        </>
    );
};

export default CheckOut;